import Vue from 'vue';
import Router from 'vue-router';
import HelloWorld from '@/components/HelloWorld';
import Index from '@/pages/index';
import NewsInfo from '@/pages/news_info';
import NewsList from '@/pages/news_list';
import Zhengshu from '@/pages/zhengshu';
import Query from '@/pages/query';

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: '/',
			name: 'index',
			component: Index,
			meta: {
				title: '中华角膜塑形镜学会，角膜塑形镜，近视防控',
				keywords: '中华角膜塑形镜学会，角膜塑形镜，近视防控',
				description: '角膜塑形镜，中华角膜塑形镜学会，近视防控，角膜塑形镜价格多少钱'
			}
		},
		{
			path: '/news_info',
			name: 'news_info',
			component: NewsInfo
		},
		{
			path: '/news_list',
			name: 'news_list',
			component: NewsList
		},
		{
			path: '/query',
			name: 'query',
			component: Query
		},
		{
        	path: '/zhengshu',
        	name: 'zhengshu',
        	component: Zhengshu
        }
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js